interface DataConfig {
  key: string;
  graph: string;
  transform: (data: any, fullData?: any) => any;
  gridColDef?: any[];
}

export const previewCallAnalyticsDataConfigs: DataConfig[] = [
  {
    key: 'call_statistics_overview.total_calls',
    graph: 'MetricCard',
    transform: (data: any, fullData: any) => ({
      title: 'Total Calls',
      value: data?.toString() || '0',
      change: `Date Range: ${fullData.date_range?.from || ''} to ${fullData.date_range?.to || ''}`,
      changeType: 'positive',
      icon: 'PhoneIcon',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      accentColor: '#667eea'
    }),
    gridColDef: [
      { field: "checkbox", headerName: "", checkboxSelection: true, headerCheckboxSelection: true, width: 50, pinned: 'left', filter: false },
      { field: "room_id", headerName: "Room ID", width: 150 },
      { field: "group_id", headerName: "Group ID", width: 150 },
      { field: "call_mode", headerName: "Call Mode", width: 150 },
      { field: "call_type", headerName: "Call Type", width: 150 },
      { field: "call_status", headerName: "Call Status", width: 150 },
      { field: "number_of_participants", headerName: "Participants", width: 150 },
      { field: "call_duration", headerName: "Call Duration", width: 150 },
      { field: "call_duration_minutes", headerName: "Duration", width: 150 },
      { field: "call_start_time", headerName: "Start Time", width: 150 },
      { field: "call_end_time", headerName: "End Time", width: 150 },
      { field: "created_at", headerName: "Created At", width: 150 },
      { field: "updated_at", headerName: "Updated At", width: 150 }
    ]
  },
  {
    key: 'call_statistics_overview.total_call_duration',
    graph: 'MetricCard',
    transform: (data: any, fullData: any) => ({
      title: 'Total Duration',
      value: data || '0h 0m',
      change: `Avg: ${fullData.call_statistics_overview?.average_call_duration || '0h 0m'}`,
      changeType: 'positive',
      icon: 'AccessTimeIcon',
      gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
      accentColor: '#4facfe'
    })
  },
  {
    key: 'call_statistics_overview.average_call_duration',
    graph: 'MetricCard',
    transform: (data: any, fullData: any) => ({
      title: 'Avg Call Duration',
      value: data || '0h 0m',
      change: `Total Participants: ${fullData.call_statistics_overview?.total_participants || 0}`,
      changeType: 'positive',
      icon: 'TrendingUpIcon',
      gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      accentColor: '#f093fb'
    })
  },
  {
    key: 'call_volume_by_type',
    graph: 'BarChart',
    transform: (data: any) => data?.chart_data?.map((item: any) => ({
      day: item.day,
      date: item.date,
      group: item.group,
      peer: item.peer,
      total_calls: item.total_calls
    })) || []
  },
  {
    key: 'calls_heatmap',
    graph: 'HeatMap',
    transform: (data: any) => data?.chart_data?.map((item: any) => ({
      date: item.date,
      hour: item.hour,
      value: item.value
    })) || []
  },
  {
    key: 'group_calls_heatmap',
    graph: 'HeatMap',
    transform: (data: any) => data?.chart_data?.map((item: any) => ({
      date: item.date,
      hour: item.hour,
      value: item.value
    })) || [],
    gridColDef: [
      { field: "checkbox", headerName: "", checkboxSelection: true, headerCheckboxSelection: true, width: 50, pinned: 'left', filter: false },
      { field: "room_id", headerName: "Room ID", width: 150 },
      { field: "group_id", headerName: "Group ID", width: 150 },
      { field: "call_mode", headerName: "Call Mode", width: 150 },
      { field: "call_type", headerName: "Call Type", width: 150 },
      { field: "call_status", headerName: "Call Status", width: 150 },
      { field: "number_of_participants", headerName: "Participants", width: 150 },
      { field: "call_duration", headerName: "Call Duration", width: 150 },
      { field: "call_duration_minutes", headerName: "Duration", width: 150 },
      { field: "call_start_time", headerName: "Start Time", width: 150 },
      { field: "call_end_time", headerName: "End Time", width: 150 },
      { field: "created_at", headerName: "Created At", width: 150 },
      { field: "updated_at", headerName: "Updated At", width: 150 }
    ]
  },
  {
    key: 'peer_calls_heatmap',
    graph: 'HeatMap',
    transform: (data: any) => data?.chart_data?.map((item: any) => ({
      date: item.date,
      hour: item.hour,
      value: item.value
    })) || [],
    gridColDef: [
      { field: "checkbox", headerName: "", checkboxSelection: true, headerCheckboxSelection: true, width: 50, pinned: 'left', filter: false },
      { field: "room_id", headerName: "Room ID", width: 150 },
      { field: "group_id", headerName: "Group ID", width: 150 },
      { field: "call_mode", headerName: "Call Mode", width: 150 },
      { field: "call_type", headerName: "Call Type", width: 150 },
      { field: "call_status", headerName: "Call Status", width: 150 },
      { field: "number_of_participants", headerName: "Participants", width: 150 },
      { field: "call_duration", headerName: "Call Duration", width: 150 },
      { field: "call_duration_minutes", headerName: "Duration", width: 150 },
      { field: "call_start_time", headerName: "Start Time", width: 150 },
      { field: "call_end_time", headerName: "End Time", width: 150 },
      { field: "created_at", headerName: "Created At", width: 150 },
      { field: "updated_at", headerName: "Updated At", width: 150 }
    ]
  },
  {
    key: 'call_duration_distribution',
    graph: 'BarChart',
    transform: (data: any) => data?.chart_data?.map((item: any) => ({
      duration: item.duration,
      count: item.count
    })) || []
  },
  {
    key: 'call_quality_distribution',
    graph: 'PieChart',
    transform: (data: any) => data?.chart_data?.map((item: any) => ({
      name: item.name,
      value: item.count,
      color: item.color
    })) || [],
    gridColDef: [
      { field: "checkbox", headerName: "", checkboxSelection: true, headerCheckboxSelection: true, width: 50, pinned: 'left', filter: false },
      { field: "room_id", headerName: "Room ID", width: 150 },
      { field: "group_id", headerName: "Group ID", width: 150 },
      { field: "call_mode", headerName: "Call Mode", width: 150 },
      { field: "call_type", headerName: "Call Type", width: 150 },
      { field: "call_status", headerName: "Call Status", width: 150 },
      { field: "number_of_participants", headerName: "Participants", width: 150 },
      { field: "call_duration", headerName: "Call Duration", width: 150 },
      { field: "call_duration_minutes", headerName: "Duration", width: 150 },
      { field: "call_start_time", headerName: "Start Time", width: 150 },
      { field: "call_end_time", headerName: "End Time", width: 150 },
      { field: "created_at", headerName: "Created At", width: 150 },
      { field: "updated_at", headerName: "Updated At", width: 150 }
    ]
  }
];